import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FlaskConical, ArrowRightLeft } from 'lucide-react';
import { useMerchantDemo } from '../hooks/useMerchantDemo';
import { categoryLabelForLang } from '../lib/shopCategoriesUi';

export default function MerchantDemoBanner() {
  const { t, i18n } = useTranslation();
  const { isDemoMerchant, category } = useMerchantDemo();
  if (!isDemoMerchant || !category) return null;

  const lang = i18n.language.startsWith('de')
    ? 'de'
    : i18n.language.startsWith('en')
      ? 'en'
      : i18n.language.startsWith('it')
        ? 'it'
        : 'fr';
  const categoryLabel = categoryLabelForLang(category, lang);

  return (
    <div
      role="status"
      className="bg-amber-50 border-b border-amber-200 text-amber-950 px-4 py-3"
    >
      <div className="max-w-6xl mx-auto flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-start gap-2.5 min-w-0">
          <FlaskConical size={20} className="shrink-0 text-amber-700 mt-0.5" aria-hidden />
          <div className="min-w-0">
            <p className="font-semibold text-sm">{t('merchantDemo.bannerTitle')}</p>
            <p className="text-xs text-amber-900/90 mt-0.5">
              {t('merchantDemo.bannerBody', { category: categoryLabel })}
            </p>
          </div>
        </div>
        <Link
          to="/demo/commerce"
          className="inline-flex items-center gap-1.5 text-xs font-semibold text-amber-900 bg-white border border-amber-300 hover:bg-amber-100 px-3 py-2 rounded-lg shrink-0 transition-colors"
        >
          <ArrowRightLeft size={14} aria-hidden />
          {t('merchantDemo.changeCategory')}
        </Link>
      </div>
    </div>
  );
}
